
const CHECKIN_ACTIONS = {
	CHECKED: 'checked',
	NOSHOW: 'noshow',
	PER_CLIENT: 'per-client'
}

export { CHECKIN_ACTIONS }
export default CHECKIN_ACTIONS




// WEBPACK FOOTER //
// ./src/enums/checkinActions.js